const reorder = (list: any[], startIndex: number, endIndex: number): any[] => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export default reorder;

export const reorderDataMap = ({ dataMap = [], source, destination }: any) => {
  const current = [...(dataMap[source.droppableId] || [])];
  const next = [...(dataMap[destination.droppableId] || [])];
  const target = current[source.index];

  if (source.droppableId === destination.droppableId) {
    const reordered = reorder(current, source.index, destination.index);
    const result = {
      ...dataMap,
      [source.droppableId]: reordered,
    };
    return {
      dataMap: result,
    };
  }

  current.splice(source.index, 1);
  next.splice(destination.index, 0, target);

  const result = {
    ...dataMap,
    [source.droppableId]: current,
    [destination.droppableId]: next,
  };

  return {
    dataMap: result,
  };
};

export function moveBetween({ list1, list2, source, destination }: any) {
  const newFirst = Array.from(list1.values);
  const newSecond = Array.from(list2.values);

  const moveFrom = source.droppableId === list1.id ? newFirst : newSecond;
  const moveTo = moveFrom === newFirst ? newSecond : newFirst;

  const [moved] = moveFrom.splice(source.index, 1);
  moveTo.splice(destination.index, 0, moved);

  return {
    list1: {
      ...list1,
      values: newFirst,
    },
    list2: {
      ...list2,
      values: newSecond,
    },
  };
}
